import API from 'src/api'
import { http } from '../boot/axios'

const getAssignmentGraphqlURL = (occcurrenceId) =>
  `${API.GRAPHQL_URL}occurrences/${occcurrenceId}/form-assignments`

const UPLOAD_TIMEOUT_MS = 180000

export default {
  URL: API.URL + 'occurrences',
  GRAPHQL_URL: `${API.GRAPHQL_URL}`,

  find (id) {
    // Sin id NO hay request: `GET occurrences/` (colección) no existe en el backend y responde 404
    // booteando Laravel completo. Rechazar local es gratis; el request basura no (incidente CPU
    // 2026-08-14).
    if (id === undefined || id === null || id === '') {
      return Promise.reject(new Error('occurrences.find: id requerido'))
    }
    return Promise.all([
      http.get(`${this.GRAPHQL_URL}occurrences/${id}`),
      http.get(`${this.GRAPHQL_URL}tasks/${id}/occurrence`)
    ]).then(([response, taskRes]) => {
      const resWithTasks = response.data
      if (taskRes?.data) {
        resWithTasks.data.taskForm = taskRes.data.task_on_form
        resWithTasks.data.taskEditing = taskRes.data.task_on_occ_editing
      }
      return resWithTasks
    })
  },

  reloadTasks (id) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}tasks/${id}/occurrence`)
        .then(res => resolve(res.data))
        .catch(error => reject(error))
    })
  },

  saveEditingTasks (id, payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}tasks/${id}/occurrenceSave`, payload)
        .then(res => resolve(res.data))
        .catch(error => reject(error))
    })
  },

  update (id, payload) {
    return new Promise((resolve) => {
      const config = payload.axiosConfig || {}
      http.put(
        `${getAssignmentGraphqlURL(id)}/${payload.form_assignment_id}`,
        payload,
        config
      )
        .then(response => resolve({ ok: true, data: response.data }))
        .catch(error => {
          console.warn('[OccurrencesService.update] error:', error)
          resolve({ ok: false, error })
        })
    })
  },

  updateFormData (occurrenceId, formAssignmentId, formData) {
    return http.post(
      `${getAssignmentGraphqlURL(occurrenceId)}/${formAssignmentId}/updateCopy`,
      formData,
      { timeout: UPLOAD_TIMEOUT_MS }
    )
      .then(res => ({ ok: true, data: res.data }))
      .catch(error => ({ ok: false, error }))
  },

  saveAndClose (payload) {
    return new Promise((resolve, reject) => {
      http.post(
        `${getAssignmentGraphqlURL(payload.occurrence_id)}/save-and-close`,
        payload.occurrenceData
      )
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },

  notify (occurrenceId) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}occurrences/${occurrenceId}/notify`)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },

  setNAGroup (id, payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}occurrences/${id}/na-group`, payload)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },

  reset (id) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}occurrences/${id}/reset`)
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  },

  forDateAndRole (payload) {
    const last = `${payload.location_id}/${payload.date}/${payload.role}`
    return new Promise((resolve, reject) => {
      http.get(
        `${this.GRAPHQL_URL}form-assignments/${payload.assignment_id}/occurrences/forDate/${last}`
      )
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  },

  sendOccurrenceByEmail (payload) {
    return new Promise((resolve, reject) => {
      http.post(
        `${this.GRAPHQL_URL}occurrences/${payload.occurrenceId}/send-checklist-by-mail`,
        payload.emailList
      )
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },

  saveOfflineAnswers (formData) {
    return http.post(
      `${this.GRAPHQL_URL}occurrences/save-offline-answers-copy`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        timeout: UPLOAD_TIMEOUT_MS
      }
    )
      .then(res => res.data)
      .catch(err => {
        throw err
      })
  },

  lastOccurrences (payload) {
    return new Promise((resolve, reject) => {
      http.get(
        `${this.GRAPHQL_URL}occurrences/last-occurrences`,
        { params: payload }
      )
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },

  saveComments (payload) {
    return new Promise((resolve, reject) => {
      http.put(`${this.GRAPHQL_URL}comments/${payload.id}`, payload)
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  },

  signaturesRoles (roles) {
    return new Promise((resolve, reject) => {
      http.post(`${API.GRAPHQL_URL}roles/`, roles)
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  },

  deleteSignature (signature) {
    return new Promise((resolve, reject) => {
      http.delete(`${API.GRAPHQL_URL}signature/${signature}`)
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  },

  getLastAnswer (payload) {
    return new Promise((resolve, reject) => {
      http.get(
        `${this.GRAPHQL_URL}occurrences/${payload.occurrence_id}/answers/${payload.item_id}`,
        { suppressConnectionToast: true }
      )
        .then(response => resolve(response.data.data))
        .catch(err => reject(err))
    })
  },

  // Arranca la exportacion async del PDF de una ocurrencia (flujo de descarga
  // interactiva). El backend encola la generacion y responde 202 con el id a
  // pollear con getPdfExportStatus.
  startPdfExport (occurrenceId) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}occurrences/${occurrenceId}/pdf-export`)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },

  // Estado de una exportacion de PDF: { status: 'pending' } mientras se genera,
  // o { status: 'ready', size_bytes, threshold_bytes, download_url } al terminar
  // (o { status: 'failed' } si fallo).
  getPdfExportStatus (exportId) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}occurrences/pdf-exports/${exportId}`)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },

  // Trae el PDF como blob desde una URL de stream (mismo dominio, sin CORS).
  // Devuelve directamente response.data (el Blob).
  fetchPdfBlob (streamUrl) {
    return new Promise((resolve, reject) => {
      http.get(streamUrl, { responseType: 'blob' })
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },

  // Trae el PDF como blob por token (ruta de descarga de una notificacion de
  // panel). Devuelve la respuesta completa para poder leer el nombre del archivo
  // del header Content-Disposition.
  fetchPdfBlobByToken (token) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}link/d/${token}/download`, { responseType: 'blob' })
        .then(response => resolve(response))
        .catch(err => reject(err))
    })
  },

  validateSyncStatus (occurrence) {
    return new Promise((resolve, reject) => {
      (async () => {
        try {
          const occurrenceId = occurrence.id

          const expectedItems = occurrence.form.items
            .filter(item => !['label', 'form-table', 'extra-properties-totals'].includes(item.type))
            .map(item => item.id)

          const resAnswers = await http.get(
            `${this.GRAPHQL_URL}occurrences/${occurrenceId}/form-assignments/answers`
          )
          const answers = resAnswers.data.data || resAnswers.data
          const answeredItems = new Set(answers.map(ans => Number(ans.item_id)))

          const resAddons = await http.get(
            `${this.GRAPHQL_URL}occurrences/${occurrenceId}/addons`
          )
          const addons = resAddons.data.data || resAddons.data
          const syncedAddons = addons.reduce((acc, addon) => {
            acc[`${Number(addon.item_id)}_${addon.type}`] = true
            return acc
          }, {})

          const missingAnswers = expectedItems.filter(
            itemId => !answeredItems.has(Number(itemId))
          )

          const requiredAddonTypes = ['picture', 'comment', 'document']
          const missingAddons = []

          occurrence.form.items.forEach(item => {
            const itemAddons = occurrence.addons[item.id] || []
            itemAddons.forEach(addon => {
              const key = `${Number(item.id)}_${addon.type}`
              if (requiredAddonTypes.includes(addon.type) && !syncedAddons[key]) {
                missingAddons.push({ item_id: item.id, type: addon.type })
              }
            })
          })

          resolve({ missingAnswers, missingAddons })
        } catch (error) {
          console.error('Error in validateSyncStatus:', error)
          reject(error)
        }
      })()
    })
  },

  getDeadlineStatus (occurrenceId) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}occurrences/${occurrenceId}/deadline-status`)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },

  authorize (occurrenceId) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}occurrences/${occurrenceId}/authorize`)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  getOccurrenceItem (occurrenceId, itemId) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}occurrences/${occurrenceId}/answers/${itemId}/last/addons`)
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}
